// components/modals/app-modals/onboarding/OnboardingProgress.jsx

const OnboardingProgress = ({ step, totalSteps }) => {
  const progress = Math.round(((step + 1) / totalSteps) * 100);

  return (
    <div style={{ marginBottom: '1.5rem' }}>
      <div
        style={{
          fontSize: '0.85rem',
          color: 'var(--green-dark)',
          opacity: 0.8,
          marginBottom: '0.4rem',
          textAlign: 'center'
        }}
      >
        Step {step + 1} of {totalSteps}
      </div>

      <div
        style={{
          height: '6px',
          width: '100%',
          backgroundColor: 'var(--green-lightest)',
          borderRadius: '999px',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${progress}%`,
            backgroundColor: 'var(--green-primary)',
            transition: 'width 0.3s ease'
          }}
        />
      </div>
    </div>
  );
};

export default OnboardingProgress;